import { render, staticRenderFns } from "./bm_location.vue?vue&type=template&id=af56dc54&"
import script from "./bm_location.vue?vue&type=script&lang=js&"
export * from "./bm_location.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports